// extracted by mini-css-extract-plugin
module.exports = {"heading":"DataDeletionInstruction_heading__G5vsY","content":"DataDeletionInstruction_content__nlFoo"};